// Configuration using environment variables
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080'
};

console.log('Frontend configuration:', config);

export default config;
